import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class profileState extends baseState {
  // 获取终端列表
  @observable profileInfo = {};
  @action
  setProfileInfo = data => this.profileInfo = data;

  getProfileInfo = data => {
    return this.fetch({
      url: apiUrl.PROFILE.INFO,
      method: 'get',
      setState: "setProfileInfo",
      data
    });
  }
}
